<template lang="html">
  <div class="alignCenter">
    <div class="col-sm-5 paddingNone">
      <select id="inputState" class="form-control" v-model="y">
        <option value=""> </option>
        <option v-for="item in year" :value="item">{{item}}</option>
      </select>
    </div>
    <div class="col-sm-1 paddingNone">
      <span>年</span>
    </div>
    <div class="col-sm-4 paddingNone">
      <select id="inputState" class="form-control" v-model="m">
        <option value=""> </option>
        <option v-for="item in month" :value="item">{{formatTime(item)}}</option>
      </select>
    </div>
    <div class="col-sm-1 paddingNone">
      <span>月</span>
    </div>
  </div>
</template>


<script>
export default {
  props: ['default', 'index'],
  data() {
    return {
      year: [],
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      y: '',
      m: '',
    }
  },
  methods: {
    formatTime(date) {
      let time = date + '';
      return time.length == 2 ? time : '0' + time
    },
    getFullDay() {
      let fullDay = new Date(this.y, this.m, 0).getDate()
      let date = `${this.y}-${this.formatTime(this.m)}`
      if (this.y && this.m) {
        this.$emit('getChildDate', { date: date, index: this.index })
      } else {
        this.$emit('getChildDate', { date: '', index: this.index })
      }
    },
    valueTime(time) {
      if (time.indexOf('0') == 0) {
        time = time.substr(1, 1)
      }
      return time
    }
  },
  mounted() {
    let date = new Date()
    let currentYear = date.getFullYear() + 10
    for (let i = currentYear - 80; i <= currentYear; i++) {
      this.year.push(i)
    }
    if (this.default) {
      console.log(this.default, "------")
      let dateArr = this.default.split('-')
      this.y = dateArr[0]
      this.m = this.valueTime(dateArr[1])
    } else {
      //this.y = currentYear
    }
    //this.y = currentYear
    this.getFullDay()
  },
  watch: {
    y(val) {
      this.getFullDay()
    },
    m(val) {
      this.getFullDay()
    },
  }
}
</script>

<style lang="css" scoped>
.paddingNone {
  padding: 0;
  margin-right: 0px;
  font-size: 13px;
}
.paddingNone span {
  display: inline-block;
}
select {
  font-size: 12px !important  ;
  padding-left: 3px;
}
</style>

<!-- <template lang="html">
  <div class="datepicker month" v-show="show">
    <div class="head">
      <span @click.stop.prevent="yearHandle(1)"><<</span>
      <span >{{year}}年</span>
      <span @click.stop.prevent="yearHandle(2)">>></span>
    </div>
    <ul>
      <li v-for="item in month" @click.stop.prevent="chooseDate(item)">{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props:["show"],
  data(){
    return{
      month:[1,2,3,4,5,6,7,8,9,10,11,12],
      year:2019
    }
  },
  methods:{
    yearHandle(type){
      if(type==1){
        this.year--
      }else {
        this.year++
      }
    },
    chooseDate(mon){
      let date = `${this.year}-${this.formatTime(mon)}`
      this.$emit("getChildDate",{date})
    },
    formatTime(date){
      let time = date + '';
      return time.length == 2 ? time : '0' + time
    },
  }
}
</script>

<style lang="css">
.datepicker{
  position: absolute;
  width: 100%;
  top: 40px;
  left: 0;
  background: #fff;
  border: 1px solid #33434b;
  border-radius: 5px;
  z-index: 1000;
}
.head{display: flex;justify-content: space-around;font-weight: normal;padding: 10px 20px;align-items: center;font-size: 15px;}
.head span{cursor: pointer;}
ul{display: flex;justify-content: space-between;padding-left: 0;padding:0 20px; flex-wrap: wrap;}
ul li{list-style: none;text-align: center;font-size: 14px;color: #333;line-height: 2;}
.month ul li{width: calc(100% / 6);}
.date{line-height: 2;color: #333;
font-weight: normal;cursor: pointer;border-radius: 3px;}
.date:hover{background: rgb(238, 238, 238);}
.date.disabled{
  color: #999;
}
.date.active{color: #fff;background: #3276b1;}
</style> -->



// WEBPACK FOOTER //
// src/components/monthpicker.vue